import { Box, Button, Flex, Text } from "@chakra-ui/react"
import { Link, useNavigate } from "react-router-dom"
import Icon from "../base-components/Icons";
import { SPACING } from "./config";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { useNavSections } from "./navigation";

const Drawer = ({ ratioInPercent, onSelect }: { ratioInPercent: number; onSelect: null | ((path: string) => void) }) => {
    const sections = useNavSections();

    // Fills its (fixed-width, sticky) container from App.tsx. ratioInPercent is
    // kept for API compatibility but no longer drives width — a percentage width
    // clipped the labels on narrow screens.
    void ratioInPercent;

    return (
        <Box textAlign="left" width="100%" rounded={"initial"} p={SPACING / 2}>
            {sections.map((section, i) => (
                <Box key={section.title ?? i} pt={section.title ? 0 : SPACING / 2}>
                    {section.title && <DrawerDivider title={section.title} first={i === 0} />}
                    {section.items.map(item => (
                        <DrawerButton key={item.path} path={item.path} title={item.title} icon={item.icon} onClick={onSelect} />
                    ))}
                </Box>
            ))}
        </Box>
    )
}

export default Drawer;

const DrawerButton = ({ path, title, icon, onClick, disabled = false }: { path: string; title: string; icon: IconDefinition; onClick: null | ((path: string) => void); disabled?: boolean }) => {
    const navigate = useNavigate();
    const currentPath = window.location.pathname;
    const isSelected = currentPath.includes(path);

    return (
        <Link to={path}>
            <Button
                variant="ghost"
                color={disabled ? "gray.400" : "inherit"}
                fontWeight={isSelected ? "600" : undefined}
                bg={isSelected ? "gray.200" : undefined}
                _dark={isSelected ? { bg: "gray.700" } : undefined}
                _hover={disabled ? {} : { bg: "gray.200", _dark: { bg: "gray.600" } }}
                onClick={event => {
                    // If holding ctrl/cmd, let the browser handle opening in new tab
                    if (event.ctrlKey || event.metaKey) {
                        return;
                    }

                    if (!disabled) {
                        navigate(path);
                        onClick?.(path);
                    }
                }}
                width={"100%"}
                justifyContent={"flex-start"}
                transition="all 0.25s ease"
            >
                <Flex flexGrow={1} alignItems={"center"}>
                    <Icon icon={icon} marginRight={SPACING / 2} />
                    <Text fontSize="small">{title}</Text>
                </Flex>
            </Button>
        </Link>
    )
};

const DrawerDivider = ({ title, first = false }: { title: string; first?: boolean }) => {
    return (
        <Box mt={first ? SPACING / 2 : SPACING * 1.5} mb={SPACING / 2} px={SPACING / 2}>
            <Text
                fontSize="x-small"
                fontWeight="700"
                textTransform="uppercase"
                letterSpacing="0.08em"
                color="gray.500"
            >
                {title}
            </Text>
            <Box w="100%" h="1px" bg="gray.200" mt={SPACING / 4} _dark={{ bg: "gray.700" }} />
        </Box>
    )
};
